import { useTranslation } from "react-i18next";
import { createComponent } from "utils/libExtend/createComponent";

export const NotFoundPage = createComponent("NotFoundPage", () => {
  const { t } = useTranslation();
  return <span>{t("notFoundPage.title")}</span>;
});
